import React from 'react';
import '../styles/SEOSection.css';

function SEOSection() {
    return (
        <section className="seo-section">
            <h2>7/24 Oto Çekici & Yol Yardım Hizmetleri</h2>
            <p>
                Acil oto çekici hizmeti mi arıyorsunuz? <strong>7/24 kesintisiz</strong> yol yardım ve araç kurtarma hizmetimizle yanınızdayız.
                <strong>Hızlı, güvenilir ve uygun fiyatlı çekici servisi</strong> sunarak, aracınızı bulunduğu yerden alıp dilediğiniz noktaya güvenle taşıyoruz.
                İster <strong>şehir içi</strong> ister <strong>şehirler arası araç taşıma</strong> olsun, profesyonel ekibimiz en kısa sürede size ulaşır.
            </p>
            <p>
                Aracınız yolda mı kaldı? Hemen bizimle iletişime geçin!
                <strong> Deneyimli ekibimiz</strong> ve <strong>modern çekici araçlarımız</strong> ile oto çekici ihtiyacınıza anında çözüm sunuyoruz.
            </p>
            <ul className="service-list">
                <li>🔹 Acil yol yardım ve oto kurtarma</li>
                <li>🔹 7/24 oto çekici hizmeti</li>
                <li>🔹 Şehir içi ve şehirler arası araç taşıma</li>
                <li>🔹 Uygun fiyatlı çekici servisi</li>
                <li>🔹 Profesyonel ve hızlı müdahale</li>
            </ul>
            <div className="keywords">
                <span>#otoçekici</span>
                <span>#acilyolyardım</span>
                <span>#otoçekicihizmeti</span>
                <span>#arackurtarma</span>
                <span>#çekicihizmeti</span>
                <span>#yoldakaldım</span>
                <span>#araçtaşıma</span>
                <span>#7/24çekici</span>
                <span>#acilçekici</span>
            </div>

            {/* Structured Data for SEO */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "name": "Oto Çekici & Yol Yardım Hizmetleri",
                    "description": "7/24 oto çekici, acil yol yardımı, araç kurtarma ve şehirler arası oto taşıma hizmetleri.",
                    "areaServed": {
                        "@type": "Place",
                        "name": "Türkiye"
                    },
                    "provider": {
                        "@type": "Organization",
                        "name": "Antalya Oto Çekici Kurtarıcı",
                        "url": "https://antalyaotocekicikurtarici.com"
                    },
                    "serviceType": "Towing Service",
                    "availableLanguage": ["Turkish"]
                })}
            </script>
        </section>
    );
}

export default SEOSection;
